import { AWSError } from 'aws-sdk';
import _ from 'lodash';

export class ErrorMessage {
  messageText?: string;
  messageFunction?: (string) => string;

  constructor(message?: string | ((string) => string)) {
    if (typeof message === 'string') {
      this.messageText = message;
    } else if (typeof message === 'function') {
      this.messageFunction = message;
    }
  }

  get(awsError: AWSError): string {
    let strErrorMsg=''
    if (this.messageText) {
      strErrorMsg=this.messageText;
    } else if (this.messageFunction) {
      strErrorMsg=this.messageFunction(awsError.message);
    }
    if (_.startsWith(_.toLower(strErrorMsg), 'you may not reuse any of your 5 previous')) {
      strErrorMsg='Your new password cannot be the same as any of your previous five passwords. Try again.';
    }
    return strErrorMsg;
  }
}
